<section class="atw-page services-page">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <div class="atw-container">

    <!-- Hero -->
    <div class="services-hero">
      <div class="services-hero-content">
        <div class="hero-badge">
          <span>{{ 'atw.servicesPage.hero.badgeNumber' | transloco }}</span>
          {{ 'atw.servicesPage.hero.badgeTitle' | transloco }}
        </div>

        <h1>
          {{ 'atw.servicesPage.hero.titleLine1' | transloco }}
          <strong>{{ 'atw.servicesPage.hero.titleStrong' | transloco }}</strong>
        </h1>

        <p>
          {{ 'atw.servicesPage.hero.description' | transloco }}
        </p>

        <div class="hero-actions">
          <a class="primary-action" href="#main-services">
 
            {{ 'atw.servicesPage.hero.primaryBtn' | transloco }}
          </a>

          <a class="secondary-action" href="#service-steps">
   
            {{ 'atw.servicesPage.hero.secondaryBtn' | transloco }}
                     <img class="img-m" src="assets/as/23.webp" alt="steps" />
          </a>
        </div>
      </div>

      <div class="services-hero-visual">
        <div class="services-visual-card">
          <div class="services-visual-icon">
            <img class="img-xl" src="assets/as/39.webp" alt="travel" />
          </div>

          <strong>{{ 'atw.servicesPage.hero.visualTitle' | transloco }}</strong>
          <p>{{ 'atw.servicesPage.hero.visualText' | transloco }}</p>

          <div class="services-tags">
            <span>{{ 'atw.servicesPage.hero.tags.visa' | transloco }}</span>
            <span>{{ 'atw.servicesPage.hero.tags.medical' | transloco }}</span>
            <span>{{ 'atw.servicesPage.hero.tags.travel' | transloco }}</span>
          </div>
        </div>

        <div class="floating-card services-floating-card">
          <img class="img-m" src="assets/as/27.webp" alt="verified" />

          <div>
            <strong>{{ 'atw.servicesPage.hero.floatTitle' | transloco }}</strong>
            <small>{{ 'atw.servicesPage.hero.floatText' | transloco }}</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Intro -->
    <section class="apply-section">
      <div class="section-title">
        <span>
          <b>{{ 'atw.servicesPage.intro.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.servicesPage.intro.title' | transloco }}</h2>
          <p>{{ 'atw.servicesPage.intro.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="apply-card services-intro-card">
        <div class="services-intro-content">
          <span>{{ 'atw.servicesPage.intro.label' | transloco }}</span>
          <h3>{{ 'atw.servicesPage.intro.heading' | transloco }}</h3>
          <p>{{ 'atw.servicesPage.intro.text' | transloco }}</p>
        </div>

        <div class="services-intro-side">
          <div class="services-side-item">
            <div>
              <img class="img-m" src="assets/as/12.webp" alt="documents" />
            </div>

            <strong>{{ 'atw.servicesPage.intro.side1Title' | transloco }}</strong>
            <p>{{ 'atw.servicesPage.intro.side1Text' | transloco }}</p>
          </div>

          <div class="services-side-item">
            <div>
              <img class="img-m" src="assets/as/50.webp" alt="global" />
            </div>

            <strong>{{ 'atw.servicesPage.intro.side2Title' | transloco }}</strong>
            <p>{{ 'atw.servicesPage.intro.side2Text' | transloco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Services -->
    <section class="apply-section" id="main-services">
      <div class="section-title">
        <span>
          <b>{{ 'atw.servicesPage.services.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.servicesPage.services.title' | transloco }}</h2>
          <p>{{ 'atw.servicesPage.services.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="services-grid">
        <div
          class="apply-card service-card"
          *ngFor="let service of services; trackBy: trackByIndex"
        >
          <div class="service-icon">
            <img
              class="img-m"
              [src]="service.iconImg"
              [alt]="service.titleKey | transloco"
            />
          </div>

          <h3>{{ service.titleKey | transloco }}</h3>
          <p>{{ service.textKey | transloco }}</p>
        </div>
      </div>
    </section>

    <!-- Features -->
    <section class="apply-section">
      <div class="section-title">
        <span>
          <b>{{ 'atw.servicesPage.features.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.servicesPage.features.title' | transloco }}</h2>
          <p>{{ 'atw.servicesPage.features.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="features-grid">
        <div
          class="apply-card feature-card"
          *ngFor="let feature of features; trackBy: trackByIndex"
        >
          <div>
            <img
              class="img-m"
              [src]="feature.iconImg"
              [alt]="feature.titleKey | transloco"
            />
          </div>

          <strong>{{ feature.titleKey | transloco }}</strong>
          <p>{{ feature.textKey | transloco }}</p>
        </div>
      </div>
    </section>

    <!-- Steps -->
    <section class="apply-section" id="service-steps">
      <div class="section-title">
        <span>
          <b>{{ 'atw.servicesPage.steps.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.servicesPage.steps.title' | transloco }}</h2>
          <p>{{ 'atw.servicesPage.steps.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="service-steps-list">
        <div
          class="apply-card service-step"
          *ngFor="let step of steps; let i = index; trackBy: trackByIndex"
        >
          <div class="step-number">
            {{ i + 1 < 10 ? '0' + (i + 1) : i + 1 }}
          </div>

          <div>
            <h3>{{ step.titleKey | transloco }}</h3>
            <p>{{ step.textKey | transloco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="apply-section">
      <div class="apply-card services-cta">
        <div>
          <span>{{ 'atw.servicesPage.cta.badge' | transloco }}</span>
          <h2>{{ 'atw.servicesPage.cta.title' | transloco }}</h2>
          <p>{{ 'atw.servicesPage.cta.text' | transloco }}</p>
        </div>

        <a class="primary-action" routerLink="/contact-us">
          <img class="img-m" src="assets/as/3.webp" alt="contact" />
          {{ 'atw.servicesPage.cta.btn' | transloco }}
        </a>
      </div>
    </section>

  </div>
</section>